import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Redireciona "/" → "/auth" preservando query params (ex.: eventId).
 * Um redirectTo estático em app.routes descarta ?eventId=.
 */
@Component({
  standalone: true,
  template: '',
})
export class RootRedirectComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const qp = this.route.snapshot.queryParams;
    const hasQuery = Object.keys(qp).length > 0;
    void this.router.navigate(['/auth'], {
      queryParams: hasQuery ? qp : undefined,
      replaceUrl: true,
    });
  }
}
